import { StyledContainer, StyledDot } from '~/components/atoms/text-box/styled';

const dots = ['top-left-dot', 'top-right-dot', 'bottom-left-dot', 'bottom-right-dot']

type TextBoxProps = {
  text: string;
  fontSize?: string;
  fontWeight?: number;
};

export const TextBox = ({ text, fontSize = '38px', fontWeight = 700 }: TextBoxProps) => {
  return (
    <StyledContainer $fontSize={fontSize} $fontWeight={fontWeight}>
      {text}
      {dots.map((position) => (
        <StyledDot key={position} className={position} />
      ))}
    </StyledContainer>
  );
};
